// componente utilizzato per chiamare i dati verso l'esterno da next.js 
// al server dati

import { API_ENDPOINT } from "./Constants";


const ApiCallGet = async (path) => {

  try{
    const response = 
      await fetch(
        `${API_ENDPOINT.BASE_URL}/${path}`,
        {
          method: "GET",
        }
      );
    if(response){
      const json = await response.json();
      
      if(json){
        return json;    
      }else{
        console.log(json.code, json.message); 
      }
    }

  } catch (error) {
    console.log(error)
  }
  
  return null;
}

export {ApiCallGet};